import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BasicShareArrowIcon } from '../../ui/Icons';

type ShareArrowIconProps = {
  iconFillColor?: string;
  iconSize?: number;
};

const ShareArrowIcon: React.FCWithChildren<ShareArrowIconProps> = ({
  iconFillColor = colors.metal,
  iconSize = 24,
}) => (
  <Box testID="share-icon">
    <BasicShareArrowIcon
      width={iconSize}
      height={iconSize}
      color={iconFillColor}
    />
  </Box>
);

export default ShareArrowIcon;
